import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  tags: {
    ...dFlex('start', 'start'),
    gap: 4,
  },
}));

export default useStyles;
